module.exports = __webpack_public_path__ + "img/96683.f6f74a59.svg";